'use client';

import { useState } from 'react';

import { useGetNotificationInboxQuery } from '@/features/notifications/api/notificationsApi';
import { useNotificationsRealtime } from '@/features/notifications/realtime/useNotificationsRealtime';
import { useIsMobile } from '@web/hooks';

import { NotificationsButton } from './NotificationsButton';
import { NotificationsDrawer } from './NotificationsDrawer';

export function NotificationsTray({
  buttonVariant = 'mini',
  viewport,
}: {
  buttonVariant?: 'mini' | 'medium';
  viewport?: 'desktop' | 'mobile';
}) {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const shouldRender =
    !viewport ||
    (viewport === 'mobile' && isMobile) ||
    (viewport === 'desktop' && !isMobile);
  const { data } = useGetNotificationInboxQuery(
    { page_size: 20 },
    { skip: !shouldRender },
  );
  const unreadCount = data?.data?.unread_count ?? 0;

  useNotificationsRealtime({ enabled: shouldRender });

  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <NotificationsButton
        unreadCount={unreadCount}
        onClick={() => setOpen(true)}
        variant={buttonVariant}
      />
      <NotificationsDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
